export const SET_ORGANIZATION = "setOrganization";
export const SET_ORGANIZATIONS = "setOrganizations";
export const CLEAR_ORGANIZATIONS = "clearOrganizations";
export const CLEAR_ORGANIZATION = "clearOrganization";
export const SET_SEGMENTS = "setSegments";
export const CLEAR_SEGMENTS = "clearSegments";
export const SET_FIELD = "setField";
export const SET_IDENTIFICATOR_CUSTOM = "setIdentificatorCustom";
export const SET_IDENTIFICATOR_CUSTOM_FIELD = "setIdentificatorCustomField";
export const CLEAR_IDENTIFICATOR_CUSTOM = "clearIdentificatorCustom";
export const SET_ORGANIZATION_STORAGE = "setOrganizationStorage";
export const SET_USER_DASHBOARD = "setUserDashboard";
export const SET_USER_ADMIN_EMAIL = "setUserAdminEmail";
export const SET_EXPORT_RANGE = "setExportRange";
export const CLEAR_EXPORT_RANGE = "clearExportRange";
export const SET_EDIT_FIELD = "setEditField";
export const SET_ORGANIZATION_EDIT = "setOrganizationEdit";
export const CLEAR_ORGANIZATION_EDIT = "clearOrganizationEdit";
